// Test comment to verify GitHub CLI integration and Cloudflare Pages deployment
import React from 'react';
import { ChatWidget } from '@/components/ChatWidget';
import { MainApp } from './MainApp';
import './styles/glass-morphism.css';

/*
function TawkWrapper({ show }: { show: boolean }) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!show) {
      // Remove all Tawk.to iframes
      document.querySelectorAll('iframe[src*="tawk.to"]').forEach((el) => el.parentNode?.removeChild(el));
      // Remove all Tawk.to scripts
      document.querySelectorAll('script[src*="tawk.to"]').forEach((el) => el.parentNode?.removeChild(el));
      // Remove Tawk.to global variables
      if ((window as any).Tawk_API) delete (window as any).Tawk_API;
      if ((window as any).Tawk_LoadStart) delete (window as any).Tawk_LoadStart;
      setIsLoaded(false);
      return;
    }

    // Defer loading until after initial page render to prevent layout shifts
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1000); // Wait 1 second after auth is ready

    return () => clearTimeout(timer);
  }, [show]);

  if (!show || !isLoaded) return null;

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: 0, 
      right: 0, 
      zIndex: 9999,
      pointerEvents: 'none' // Allow clicks to pass through container
    }}>
      <TawkMessengerReact
        propertyId="683dbb66b22d89190f2488c7"
        widgetId="1isoi825f"
      />
    </div>
  );
}
*/

function App() {
  return (
    <>
      {/* Chat Widget - Public function, completely isolated from auth */}
      <ChatWidget />
      {/* Main app with all auth logic */}
      <MainApp />
    </>
  );
}

export default App;
//comment